import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo } from 'react';
import { Control } from './index';
function ControlWithoutValidationImpl(props, ref) {
    return (_jsx(Control, { help_id: props.help_id != null ? props.help_id : null, validation_result: null, validation_warnings_result: null, ...props, ref: ref }));
}
export const ControlWithoutValidation = memo(forwardRef(ControlWithoutValidationImpl));
